import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[app-dropdown-host]'
})
export class DropdownHostDirective {
  constructor(
    public viewContainerRef: ViewContainerRef,
    public templateRef: TemplateRef<unknown>
  ) { }
}
